export function initStep3() {
    if ($('.id--17').length) {
        step3ContentLoaded();
    }
}

function moveStep3Elements() {
    const checkoutContent = document.getElementById("checkoutContent");
    const orderSummary = document.querySelector(".order-summary");
    const orderSummaryInner = document.querySelector(".order-summary-inner");
    const nextStep = document.querySelector(".next-step");
    const consentWrapper = document.querySelector(".form-group.js-validated-element-wrapper.consents input#consents9")?.closest(".form-group");
    const billingAddressBox = document.querySelector(".co-box.co-billing-address");
    const companyCheckbox = document.querySelector(".form-group.company-shopping.unveil-wrapper");

    if (checkoutContent) {
        const cartInfoWrapper = document.createElement("div");
        cartInfoWrapper.classList.add("cart-info-wrapper");

        while (checkoutContent.firstChild) {
            cartInfoWrapper.appendChild(checkoutContent.firstChild);
        }

        checkoutContent.appendChild(cartInfoWrapper);

        if (orderSummary) {
            const cartSummaryWrapper = document.createElement("div");
            cartSummaryWrapper.classList.add("cart-summary-wrapper");
            cartSummaryWrapper.appendChild(orderSummary);

            if (nextStep) {
                orderSummary.appendChild(nextStep);
            }

            checkoutContent.appendChild(cartSummaryWrapper);
        }

        if (billingAddressBox && companyCheckbox) {
            billingAddressBox.appendChild(companyCheckbox);
        }

        if (orderSummaryInner && consentWrapper) {
            orderSummaryInner.appendChild(consentWrapper);
        }
    }
}

function renameStep3Texts() {

}

function step3ContentLoaded() {
    moveStep3Elements();
    renameStep3Texts();
    console.log('cart 3');
}